import React from 'react';
import { Check } from 'lucide-react';
import { aboutData } from '../data/mock';

export const About = () => {
  return (
    <section id="about" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-charcoal mb-4">
              {aboutData.title}
            </h2>
            <div className="w-24 h-1 bg-gold mx-auto rounded-full" />
          </div>

          {/* Description */}
          <div className="mb-12 space-y-4">
            <p className="text-lg text-charcoal-400 leading-relaxed text-center">
              {aboutData.description}
            </p>
            <p className="text-lg text-charcoal-400 leading-relaxed text-center font-medium">
              {aboutData.subdescription}
            </p>
          </div>

          {/* Highlights Grid */}
          <div className="grid sm:grid-cols-2 gap-6">
            {aboutData.highlights.map((highlight, index) => (
              <div
                key={index}
                className="flex items-start space-x-4 p-6 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow border border-gray-100"
              >
                <div className="flex-shrink-0 mt-1">
                  <div className="w-6 h-6 rounded-full bg-gold-100 flex items-center justify-center">
                    <Check size={14} className="text-gold" />
                  </div>
                </div>
                <p className="text-charcoal font-medium">{highlight}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
